import { getIsSidebarExpanded } from "Areas/Sidebar";
import { REDUX_ROUTING_PAGE_NAMESPACE } from "Common/routingUtils";
import { connect } from "react-redux";
import AppPage from "./appPage";
import { getSelf } from "App/appPage/profile/userInfo";
import { getActiveDocumentType } from "Areas/Sidebar/Documents/redux/selectors";
const mapStateToProps = (state, ownProps) => ({
    routingPage: state[REDUX_ROUTING_PAGE_NAMESPACE].key,
    sidebarWidth: ownProps.sideBar.type.getWidth(state[REDUX_ROUTING_PAGE_NAMESPACE].key, getIsSidebarExpanded(state)),
    user: getSelf(state),
    documentType: getActiveDocumentType(state)
});
export default connect(mapStateToProps)(AppPage);
